/**
 * Created by fers on 25.02.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

export default class MarkChannelErrorMutation extends Relay.Mutation {

    static propTypes = {
        actionComment: PropTypes.string,
        actionIgnore: PropTypes.bool,
        actionIgnoreForFuture: PropTypes.bool,
        actionMarkOk: PropTypes.bool,
        channel: PropTypes.object,
        channelDef: PropTypes.object,
        channelError: PropTypes.object,
        flow: PropTypes.object,
        flowDef: PropTypes.object,
        organisation: PropTypes.object,
    };

    static fragments = {
        channel: () => Relay.QL`
            fragment on Channel {
                organisation_id,
                realId,
                id,
            }
            `,
    };

    getMutation() {
        return Relay.QL`mutation {markChannelError}`;
    }

    getFatQuery() {
        return Relay.QL`
            fragment on MarkChannelErrorPayload {
                channelError {
                    id,
                    realId,
                    ignoredError,
                    ignoreForFuture,
                    hasError,
                },
                channel {
                    id,
                },
                channelDef {
                    id,
                },
                flow {
                    id,
                },
                flowDef {
                    id,
                },
                organisation {
                    id,
                },
                
            }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [this.getFatQuery()],
        }];
    }

    getVariables() {
        return {
            channel_id: this.props.channel ? this.props.channel.realId : null,
            channelDef_id: this.props.channelDef ? this.props.channelDef.realId : null,
            flowDef_id: this.props.flowDef ? this.props.flowDef.realId : null,
            flow_id: this.props.flow ? this.props.flow.realId : null,
            organisation_id: (this.props.organisation ? this.props.organisation.realId : null) || (this.props.flow ? this.props.flow.organisation_id : null) || (this.props.channel ? this.props.channel.organisation_id : null),
            id: this.props.channelError ? this.props.channelError.realId : null,
            actionComment: this.props.actionComment,
            actionIgnore: this.props.actionIgnore,
            actionIgnoreForFuture: this.props.actionIgnoreForFuture,
            actionMarkOk: this.props.actionMarkOk,
        };
    }
}
